<template>
<div>
  <h3 style="float: left; margin-right: 15px">{{signalData.assetName}}/{{signalData.name}}</h3>
  <DxButton
    text="Save changes"
    type="success"
    style="float: right; margin-left: 15px"
    @click="saveChanges"
  />
</div>
<DxForm :form-data="signalData" label-location="left" :min-col-width="350" @field-data-changed="updateFormInfo">
  <DxGroupItem
    :col-count="2"
    caption="System Information"
  >
    <DxSimpleItem data-field="name" :editor-options="{ disabled: true }" :label="{ text: 'Name'}"/>
    <DxSimpleItem data-field="id" :editor-options="{ disabled: true }" :label="{ text: 'System id'}"/>
    <DxSimpleItem data-field="label" :label="{ text: 'Descriptive Name'}"/>
    <DxSimpleItem data-field="units" :editor-options="{ hint: 'measurement units' }"/>
    <DxSimpleItem
      :editor-options="{ dataSource: signalTypeList, displayExpr: 'name', valueExpr: 'id' }"
      data-field="signalType"
      editor-type="dxSelectBox"
    />
    <DxSimpleItem
      :editor-options="{
      dataSource: assetList,
      displayExpr: 'name',
      valueExpr: 'name',
    }"
      data-field="assetName"
      editor-type="dxSelectBox"
    />
  </DxGroupItem>
</DxForm>

<DxForm :disabled="!pointExist.value" :form-data="pointData" label-location="left" :min-col-width="350" @field-data-changed="updateFormInfo">
  <DxGroupItem
    :col-count="2"
  >
    <DxSimpleItem data-field="limits_enabled" editor-type="dxCheckBox" :label="{ text: 'Value limits enabled'}" />
    <DxSimpleItem/>
    <DxSimpleItem v-if="pointData.limits_enabled" data-field="min_value" editor-type="dxNumberBox" :label="{ text: 'Minimun value'}" :editor-options="{ disabled: !pointData.limits_enabled }"/>
    <DxSimpleItem v-if="pointData.limits_enabled" data-field="max_value" editor-type="dxNumberBox" :label="{ text: 'Maximun value'}" :editor-options="{ disabled: !pointData.limits_enabled }"/>
  
  </DxGroupItem>
</DxForm>


<DxForm :form-data="signalData" label-location="left" :min-col-width="350" @field-data-changed="updateFormInfo">
  <DxGroupItem
    caption="DataSource Options"
    :col-count="2"
    css-class="third-group"
  >
    <DxSimpleItem 
      data-field="staticValue" 
      :editor-options="{ disabled: !signalTypeIsStatic }" 
      :label="{ text: 'Static Value'}"/>
    <DxSimpleItem 
      data-field="isModbusPoint" 
      editor-type="dxCheckBox" 
      :editor-options="{ disabled: signalTypeIsVirtual||signalTypeIsStatic }" 
      :label="{ text: 'Is ModBus datapoint'}" />
    <DxSimpleItem 
      data-field="varEvtDestination" 
      editor-type="dxSelectBox"
      :editor-options="{  items: varEvtDestinationList, disabled: !signalTypeIsVariable }" 
      :label="{ text: 'Updates destination'}" />
    <DxSimpleItem 
      data-field="virtualCodeEnabled" 
      editor-type="dxCheckBox" 
      :editor-options="{ disabled: !signalTypeIsVirtual }" 
      :label="{ text: 'Get value from Code'}" />
    <DxSimpleItem 
      data-field="virtualCodeSamplingPeriod" 
      editor-type="dxNumberBox" 
      :editor-options="{ disabled: !signalTypeIsVirtual, max: 3600*1000, min: 500 }" 
      :label="{ text: 'Executing Period (ms)'}" />
  </DxGroupItem>
</DxForm>

<CodeEditor ref="codeWindow" v-if="signalData.virtualCodeEnabled" :code="loadedCode" :readOnly="false" language="javascript"/>
<DxForm :form-data="modbusData" v-if="signalData.isModbusPoint" label-location="left" :min-col-width="350" @field-data-changed="updateFormInfo">
  <DxGroupItem caption="ModBus DataSource" css-class="third-group" :col-count="2" >
    <DxSimpleItem 
      data-field="sysSamplingPeriod" 
      :label="{ text: 'Polling Period (ms)'}"
      editor-type="dxNumberBox"
      :editor-options="{ max: 3600*1000, min: 500 }" />
    <DxSimpleItem
      :editor-options="{ items: modbusMemoryAreasList }"
      data-field="mbMemoryArea"
      editor-type="dxSelectBox"
      :label="{ text: 'Modbus Memory Area'}"
    />
    <DxSimpleItem 
      data-field="address" 
      editor-type="dxNumberBox"
      :editor-options="{ max: 65535, min: 0 }"
      :label="{ text: 'Memory Address'}" />
    <DxSimpleItem
      data-field="dataType"
      editor-type="dxSelectBox"
      :editor-options="{ items: modbusDataTypeList }"
      :label="{ text: 'Modbus Data Type'}" />
    <DxSimpleItem 
      data-field="charSize" 
      editor-type="dxNumberBox"
      :editor-options="{ disabled: !modbusTypeIsString }" 
      :label="{ text: 'String size', max: 1000, min: 0 }"/>
    <DxSimpleItem 
      data-field="encoding" 
      editor-type="dxSelectBox"
      :editor-options="{ items: modbusEncodingTypeList, disabled: !modbusTypeIsString } "
      :label="{ text: 'String encoding'}" />
    <DxSimpleItem 
      data-field="scaleFactor" 
      editor-type="dxNumberBox"
      :editor-options="{ disabled: modbusTypeIsString||modbusTypeIsBoolean, max: 1000000, min: -1000000}" 
      :label="{ text: 'Scale Factor'}" />
    <DxSimpleItem 
      data-field="offset" 
      editor-type="dxNumberBox"
      :editor-options="{ disabled: modbusTypeIsString||modbusTypeIsBoolean, max: 1000000, min: -1000000}" 
      :label="{ text: 'Offset'}" />
    <DxSimpleItem 
      data-field="maxVal" 
      editor-type="dxNumberBox"
      :editor-options="{ disabled: modbusTypeIsString||modbusTypeIsBoolean, max: 1.79E+308, min: -1000000}" 
      :label="{ text: 'Max Value'}" />
    <DxSimpleItem 
      data-field="minVal" 
      editor-type="dxNumberBox"
      :editor-options="{ disabled: modbusTypeIsString||modbusTypeIsBoolean, max: 1000000, min: -1.79E+308}" 
      :label="{ text: 'Min Value'}" />
    <DxSimpleItem 
      data-field="outOfRangeBehavior" 
      editor-type="dxSelectBox"
      :editor-options="{ items: modbusOutOfRangeBhList, disabled: modbusTypeIsString||modbusTypeIsBoolean } "
      :label="{ text: 'OutOfRange Action'}" />

  </DxGroupItem>
</DxForm>

<DxForm :form-data="signalData"  label-location="left" :min-col-width="350">
  <DxGroupItem caption="Signal IoT configuration" :col-count="2" >
    <DxSimpleItem data-field="isIoT" editor-type="dxCheckBox" :label="{ text: 'IoT signal'}"/>
    <DxSimpleItem data-field="isKpi" editor-type="dxCheckBox" :label="{ text: 'Show as Kpi'}"/>
    <DxSimpleItem
      :editor-options="{items: kpiTypesList}"
      data-field="kpiType"
      editor-type="dxSelectBox"
    />
  </DxGroupItem>
</DxForm>

<DxForm :form-data="signalData"  label-location="left" :min-col-width="350">
  <DxGroupItem caption="Storage options" :col-count-by-screen="{ sm: 2, md: 3, lg: 3}">
    <DxSimpleItem 
      data-field="dbStorageEnabled" 
      editor-type="dxCheckBox" 
      :label="{ text: 'Storage Enabled'}"
    />
    <DxSimpleItem
      data-field="dbFieldType"
      editor-type="dxSelectBox"
      :editor-options="{ disabled: !signalData.dbStorageEnabled, dataSource: storageFTypeList, valueExpr:'id', displayExpr:'name' }"
      :label="{ text: 'Field Type (DB)'}"
    />
    <DxSimpleItem 
      data-field="dbSamplingPeriod" 
      editor-type="dxNumberBox"
      :editor-options="{ disabled: !signalData.dbStorageEnabled, max: 3600*1000, min: 500 }" 
      :label="{ text: 'Sampling Period (DB)'}"
    />
  </DxGroupItem>
</DxForm>

</template>

<script>
import { ref, reactive, computed } from 'vue'
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
} from 'devextreme-vue/form';
import CodeEditor from './code-editor.vue';
import DxButton from 'devextreme-vue/button';
import RawDataService from '../services/RawDataServiceTemplate';
import DataService from '../services/DataServiceTemplate';
import notify from 'devextreme/ui/notify';

const mySignal = {
    name: "signal",
    units: "",
    label: "unknown signal", 
    signalType: "state", 
    isKpi: false,
    kpiType: null,
    kpiConfig: null,
    assetName: "asset",
    dbSamplingPeriod: 1000,
    dbStorageEnabled: false,
    dbFieldType: 0,
    id: -1,
    isIot: false,
    staticValue: null,
    virtualCodeSamplingPeriod: null, 
    isModbusPoint: false, 
    virtualCodeEnabled: false, 
    varEvtDestination: null,
  };

  const myPoint = {
    id:0,
    limits_enabled: true,
    max_value:0,
    min_value:0
  };

  const modBusPoint = {
      "offset":null,
      "mbMemoryArea": null,
      "address": 0,
      "scaleFactor": null,
      "dataType": "UInt8",
      "charSize": null,
      "encoding": null,
      "sysSamplingPeriod": 2000,
      "outOfRangeBehavior":"",
    }

export default {
  components: {
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    DxButton,
    CodeEditor,
  },
  props: {
    signalId: {
      type: Number,
      default: null
    }
  },
  setup(props) {

    const stErrorCb = err => { notify(err.message, "error", 3000); }
    const signalsDataService = new RawDataService('masters/signals');
    const staticsDataService = new RawDataService('statics/lists');
    const assetsDataService = new DataService('masters/assets', 'assetId');
    const signalTypeDataService = new DataService('statics/tables/signalTypes', 'id');
    const storageFTypeDataService = new DataService('statics/tables/storageFieldTypes', 'id');
    //const graphGroupsDataService = new DataService('masters/graphGroups', 'id');

    const modbusData = new reactive(modBusPoint);
    const signalData = new reactive(mySignal);
    const pointData = new reactive(myPoint);
    const pointExist = new reactive({value:false})
    const loadedCode = ref(`export const getValue = function(readSignalVal) {
  //enter your code here
  //const assetSignalValue = readSignalVal('asset_name', 'signal_name');
  return null;
  //make sure to return a valid value
}`);
    let isLoading = true;
    const codeWindow = ref(null);

    const loadSignal = async (signalId) => {
      // try{
        isLoading = true;

        const mySignalDataService = new RawDataService('masters/signals/'+signalId);
        const sData = await signalsDataService.getByKey(signalId);
        Object.assign(signalData, sData);
        signalData.virtualCodeEnabled = !!(sData.virtualCodeSamplingPeriod);

        if(sData.codeScript_id){
          const signalCode = await mySignalDataService.getByKey('code');
          const codeEditor = codeWindow.value;
            loadedCode.value = signalCode; //preload code
            if(codeEditor) codeEditor.setContent(signalCode); //trigger change if already loaded
        }else{
          signalData.isModbusPoint = false;
        }
        try{
          const mbData = await mySignalDataService.getByKey('modbusPoint');
          Object.assign(modbusData, mbData);
          signalData.isModbusPoint = true;
        }catch (error){
          signalData.isModbusPoint = false;
          isLoading = false;
          if(error.response.status!=404)
            throw error
        }

        // point
        const myPointDataService = new RawDataService('sunspec/config/enfyoPoints');
        const pData = (await myPointDataService.getAll()).find(s => s.enfyoSignal_id == signalData.signalId);
        if (pData){
          Object.assign(pointData, pData);
          console.log(sData)
          if(sData.access == 'RW'){
            pointExist.value=true;
            if(pData.min_value==0 && pData.max_value==0) pointData.limits_enabled=false
            else pointData.limits_enabled=true;
          }else{
            pointExist.value=false;
            pointData.limits_enabled=false
          }
        }else{
          pointExist.value=false
        }
        
  

        isLoading = false;
      // }
      // catch(error){ stErrorCb(error) }
    }
    
    loadSignal(props.signalId);
    
    const modbusTypeIsString = computed(() => (modbusData.dataType=='string') )
    const modbusTypeIsBoolean = computed(() => (modbusData.dataType=='boolean') )
    const signalTypeIsVirtual = computed(() => (signalData.signalType=='virtual') )
    const signalTypeIsStatic = computed(() => (signalData.signalType=='static') )
    const signalTypeIsVariable = computed(() => (signalData.signalType=='variable') )
    const signalTypeIsState = computed(() => (signalData.signalType=='state') )

    const assetList = ref([]);
    const signalTypeList = ref ([]);
    const storageFTypeList = ref([]);
    const kpiTypesList = ref([]);
    const modbusMemoryAreasList = ref([]);
    const modbusEncodingTypeList = ref([]);
    const modbusOutOfRangeBhList = ref([]);
    const modbusDataTypeList = ref([]);
    const varEvtDestinationList = ref([]);
    
    assetsDataService.dataStore.load().then( res => {
      assetList.value = res.data;
    });
    signalTypeDataService.dataStore.load().then( res => {
      signalTypeList.value = res.data;
    });
    storageFTypeDataService.dataStore.load().then( res => {
      storageFTypeList.value = res.data;
    });
    staticsDataService.getByKey('signalKpiTypes').then(res => {
      kpiTypesList.value = res;
    }).catch(stErrorCb);
    staticsDataService.getByKey('modbusEncodingTypes').then(res => {
      modbusEncodingTypeList.value = res;
    }).catch(stErrorCb);
    staticsDataService.getByKey('modbusDataTypes').then(res => {
      modbusDataTypeList.value = res;
    }).catch(stErrorCb);
    staticsDataService.getByKey('modbusMemoryAreas').then(res => {
      modbusMemoryAreasList.value = res;
    }).catch(stErrorCb);
    staticsDataService.getByKey('modbusOutOfRangeBh').then(res => {
      modbusOutOfRangeBhList.value = res;
    }).catch(stErrorCb);
    staticsDataService.getByKey('varEvtDestinations').then(res => {
      varEvtDestinationList.value = [...res, null];
    }).catch(stErrorCb);
    
    const updateFormInfo = (e)=>{
      if(isLoading) return ;
      if(e.dataField == 'signalType'){
        switch (e.value) {
          case 'static':
            signalData.isModbusPoint = false;
            modbusData.sysSampligPeriod = 0;
            signalData.virtualCodeEnabled = false;
            signalData.virtualCodeSamplingPeriod = 0;
            break;
          case 'virtual':
            signalData.staticValue = null;
            signalData.isModbusPoint = false;
            modbusData.sysSampligPeriod = 0;
            break;
          case 'state':
          case 'variable':
            signalData.staticValue = null;
            signalData.virtualCodeEnabled = false;
            signalData.virtualCodeSamplingPeriod = 0;
            break;
        }
      }
      if(e.dataField == 'virtualCodeEnabled'){
        if(e.value == false){
          signalData.virtualCodeSamplingPeriod = 0;
        }
      }
      if(e.dataField == 'virtualCodeSamplingPeriod'){
        if(e.value > 0){
          signalData.virtualCodeEnabled = true;
        }
      }
      if(e.dataField == 'dataType'){
        if(e.value == 'string'){
          modbusData.charSize = 2;
          modbusData.encoding = 'utf-8';
          modbusData.scaleFactor = null;
        }
        else if( e.value == 'boolean'){
          modbusData.charSize = null;
          modbusData.encoding = null;
          modbusData.scaleFactor = null;
        }
        else{
          modbusData.charSize = null;
          modbusData.encoding = null;
          modbusData.scaleFactor = 1;
        }
      }
    }

    const saveChanges = async () => {
      try{
        const action = {};
        const mySignalDataService = new RawDataService('masters/signals/'+signalData.signalId);
        const sigUpdate = await signalsDataService.update(props.signalId, signalData);
        action.sigUpdate = sigUpdate.isOk;

        if(signalData.isModbusPoint){
          const mbUpdate = await mySignalDataService.update('modbusPoint', modbusData);
          action.mbUpdate = mbUpdate.isOk;
        }
        else{
          try{
            const res = await mySignalDataService.remove('modbusPoint');
            action.mbUpdate = res.isOk
          }catch(error){
            if(error.response?.status!=404) throw error
            action.mbUpdate = true;
          }
        }

        if(signalData.virtualCodeEnabled || signalData.codeScript_id){
          const codeEditor = codeWindow.value;
          if(codeEditor){ //get code
            loadedCode.value = codeEditor.getContent();
          }
          //TODO: test code for exec before sending
          //create or update code
          const codeUpdate = await mySignalDataService.update('code', { code: loadedCode.value });
          action.codeUpdate = codeUpdate.isOk;
        }
        
        // point
        if(pointExist.value){
          const myPointDataService = new RawDataService('sunspec/config/enfyoPoints');
          if(pointData.limits_enabled){
            await myPointDataService.update(pointData.id, {max_value:pointData.max_value,min_value:pointData.min_value});
          }else{
            await myPointDataService.update(pointData.id, {max_value:0,min_value:0});
          }
          
        }
        
     
        notify("signal has been updated "+JSON.stringify(action), "success", 4000);

        
       }  
      catch(error){
        stErrorCb(error);
      }
      
    }
    
    const reload = () => { loadSignal(props.signalId); }
    const loadById = (signalId) => { loadSignal(signalId); }

    return {
      signalData,
      pointData,
      pointExist,
      modbusData,

      assetList,
      signalTypeList,
      storageFTypeList,
      modbusEncodingTypeList,
      modbusDataTypeList,
      modbusMemoryAreasList,
      modbusOutOfRangeBhList,
      varEvtDestinationList,

      modbusTypeIsString,
      modbusTypeIsBoolean,
      signalTypeIsVirtual,
      signalTypeIsStatic,
      signalTypeIsVariable,
      signalTypeIsState,

      loadedCode,
      codeWindow,
      kpiTypesList,

      updateFormInfo,
      saveChanges,
      reload,
      loadById,
    }
  },
}
</script>

<style>
.third-group {
  background-color: rgba(205, 205, 205, 0.15);
  padding: 10px 10px 10px 0px;
}

</style>
